export default __webpack_public_path__ + "static/slika5-32a379823a1c84ba470bde79ddc0868a.jpg";